module.exports = __webpack_public_path__ + "static/verification-d90fe767265626639cfd138e30095360.svg";